module.exports = __webpack_public_path__ + "img/klarna.3e54143b.svg";